import React from 'react';
import styled from '@emotion/styled';

import Text from '../common/Text';
import Heading3 from '../common/Heading3';
import Column from '../common/layout/Column';
import { useTranslation } from 'react-i18next';

interface Props {
  name?: string;
  size?: string;
  price: number;
  notReturnable?: boolean;
  quantity?: number;
  isQuantityHidden?: boolean;
  currency: string;
}

const Container = styled('div')`
  margin-left: 16px;
  overflow: hidden;
`;

const Title = styled('div')`
  width: 100%;
  margin-bottom: 2px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  word-break: break-all;
  overflow: hidden;
`;

const NotEligibleReason = styled(Text)`
  display: block;
  font-weight: 500;
  margin-top: 8px;
`;

function ProductInfo(props: Props) {
  const { name, size, price, currency, notReturnable, quantity, isQuantityHidden } = props;
  const { t } = useTranslation();

  return (
    <Container>
      <Title className={size}>
        <Heading3>{name}</Heading3>
      </Title>
      <Column spacing={4}>
        {size && (
          <Text secondary small>
            {t('productSize')}: {size}
          </Text>
        )}
        <Text secondary small>
          {t('productPrice')}: {formatPrice(price, currency)}
        </Text>
        {!isQuantityHidden && (
          <Text secondary small>
            {t('productQuantity')}: {quantity}
          </Text>
        )}
      </Column>
      {notReturnable && <NotEligibleReason small>{t('genericNonEligibleReason')}</NotEligibleReason>}
    </Container>
  );
}

function formatPrice(value: number, currency: string): string {
  return `${value.toFixed(2)} ${currency}`;
}

export default React.memo(ProductInfo);
